import { Category } from '@/core/entity';
import { CategoryInput, PresenterFunc, UpdaterFunc, ICategoryGateway } from '@/core/interface';

// tslint:disable-next-line max-classes-per-file
export class CreateCategory {
  constructor(
    private readonly categoryGateway: ICategoryGateway,
  ) { }

  public async execute(
    input: CategoryInput,
    presenter: PresenterFunc<Category | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.categoryGateway.createCategory(input, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}

// tslint:disable-next-line max-classes-per-file
export class RemoveCategory {
  constructor(
    private readonly categoryGateway: ICategoryGateway,
  ) { }

  public async execute(
    id: string,
    presenter: PresenterFunc<Category | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.categoryGateway.removeCategory(id, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}

// tslint:disable-next-line max-classes-per-file
export class UpdateCategory {
  constructor(
    private readonly categoryGateway: ICategoryGateway,
  ) { }

  public async execute(
    id: string,
    input: CategoryInput,
    presenter: PresenterFunc<Category | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.categoryGateway.updateCategory(id, input, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
